import Vue from 'vue'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import _ from 'lodash'

Vue.use(VueGoodTablePlugin)

export default Vue.component('lostpet-search-table', {
  props: ['pageResultLimit', 'rows', 'loading'],
  data() {
    return {
      errorMessage: '',
      listingId: null,
      columns: [
        {
          label: '',
          field: 'avatar',
          tdClass: 'vgt-table__avatar-field',
        },
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Place',
          field: 'place',
        },
        {
          label: 'Date lost/found',
          field: 'dateLostOrFound',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yy',
          thClass: 'vgt-left-align',
          tdClass: 'vgt-left-align',
        },
        {
          label: 'Date listed',
          field: 'createdDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd/MM/yy HH:mm:ss',
          hidden: true, // Used for sort but column not displayed
        },
        {
          label: '',
          field: 'listingPreviewLink',
        },
      ],
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPage: parseInt(this.pageResultLimit),
        position: 'bottom',
        perPageDropdownEnabled: false,
        dropdownAllowAll: false,
        nextLabel: 'Next',
        prevLabel: 'Prev',
        ofLabel: 'of',
        pageLabel: 'Page',
      },
    }
  },
})
